'use strict';

import React from 'react'

import bemit from '@function/bemit'

import { formatNum, isTrue } from '@root/utility'

const { moment } = window;

export default function CreditNoteRow ({ data, blank=true, fields, ...props })
{
	moment.locale('fr');

	let row_class = 'c-dashboard__row';

	if (isTrue(data.draft)) row_class += ' row-bg-orange';

	const chip_color = data.payment_status === 'paid'
	? 'green'
	: data.payment_status === 'partially_paid'
	? 'blue'
	: 'red';

	return (
		<div className={ row_class }>

			<div className="c-dashboard__cell CreditNote-date">
				{ moment(data.date).format('DD/MM/YYYY') }
			</div>

			<div className="c-dashboard__cell CreditNote-name">

				<div className="c-dashboard__long-text">
					{ data.name }
				</div>

			</div>

			<div className="c-dashboard__cell CreditNote-order_number">
				{ data._bill?.order_number }
			</div>

			<div className="c-dashboard__cell CreditNote-bill_number">
				{ data._bill?.text_number }
			</div>

			<div className="c-dashboard__cell CreditNote-number">
				{ data.text_number }
			</div>

			<div className="c-dashboard__cell CreditNote-amount">
				{ '-' + formatNum(data.total_price, '0,0[.]00') }
				&nbsp;€
			</div>

			<div className="c-dashboard__cell CreditNote-payment_status">
				<div className={ bemit('c-chip', [chip_color]) }>
					<span className="c-chip__text">
						{
							data.payment_status === 'paid'
							? 'Réglé'
							: data.payment_status === 'partially_paid'
							? 'Partiel'
							: 'En attente'
						}
					</span>
				</div>
			</div>

			<div className="c-dashboard__cell CreditNote-remaining_unpaid">
				{ formatNum(data.remaining_unpaid, '0,0[.]00') }
				&nbsp;€
			</div>

			<div className="c-dashboard__cell CreditNote-PDF">
				<a className="c-btn c-btn--icon c-btn--ghost" target="_blank"
					rel="noreferrer" type="application/pdf"
					href={ '/PDF/avoir/' + data.id }>
					<svg className="o-svg-icon o-svg-icon--PDF c-btn__icon">
						<use xlinkHref="/images/icons.svg#svg-icon-PDF"></use>
					</svg>
					PDF
				</a>
				<a className="u-link-only" target="_blank"
					rel="noreferrer" type="application/pdf"
					href={ '/PDF/avoir/' + data.id }>
					<span className="u-readers-only">
						Télécharger l'avoir
					</span>
				</a>
			</div>

		</div>
	);
}